import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment_ from 'moment';
const moment = moment_;
import {Moment} from 'moment';
import locale from './decorators/locale-decorator';
import direction from './decorators/dir-decorator';
import viewType from './decorators/view-type-decorator';
import {DateUtilsService} from './utils/date-utils.service';
import {nwDirection, NwRange, nwView} from './types';
import {IconsUtilsService} from './utils/icons-utils.service';
@Component({
  selector: 'nw-calendar',
  templateUrl: 'nw-calendar.component.html',
  styleUrls: [
    'assets/vendor/bootstrap/dist/css/bootstrap.min.css',
    'assets/css/open-sans.css',
    'assets/css/roborto-font.css',
    'nw-calendar.component.css'
  ]
})
export class NwCalendarComponent implements OnInit {

  @viewType
  @Input()
  viewType: nwView;

  @locale
  @Input()
  locale: string;

  @direction
  @Input() dir: nwDirection;

  @Input()
  private range: {start?: Date ,  end?: Date };

  @Output() private selectedDateChange = new EventEmitter<Date>();
  @Output() private navigate = new EventEmitter<NwRange>();
  private _selectedDate: Moment;
  days: Moment[] = [];
  private currentDate: Moment;
  private from_date;
  private to_date;


  @Input() disabledDate = (date: Date) => {
    return false;
  }


  constructor(
    public dateUtils: DateUtilsService,
    public iconsUtils: IconsUtilsService) {}

  ngOnInit() {
    moment.locale(this.locale);
    if (this.viewType === 'week') {
      this.from_date = moment().startOf('week');
      this.to_date = moment().endOf('week');
    } else {
      this.from_date = (moment().startOf('month')).startOf('week');
      this.to_date = (moment().endOf('month')).endOf('week').add(1, 'week');
    }
    this.initCalendar();
  }

  prev(year?) {
    year ? this.prevYear() : this.viewType === 'week' ? this.prevWeek() : this.prevMonth();
    // this.selectedDate = null;
    this.navigate.emit({
      start: this.from_date.toDate(),
      end: this.to_date.toDate()
    });
  }

  next(year?) {
    year ? this.nextYear() : this.viewType === 'week' ? this.nextWeek() : this.nextMonth();
    // this.selectedDate = null;
    this.navigate.emit({
      start: this.from_date.toDate(),
      end: this.to_date.toDate()
    });
  }


   prevWeek() {
    this.from_date = this.from_date.clone().subtract(1, 'w');
    this.to_date = this.to_date.clone().subtract(1, 'w');
    this.initCalendar();
  }

  nextWeek() {
    this.from_date = this.from_date.clone().add(1, 'w');
    this.to_date = this.to_date.clone().add(1, 'w');
    this.initCalendar();
  }

  prevMonth() {
    const prevMonth = this.currentDate.clone().subtract(1, 'month');
    this.from_date = (prevMonth.clone().startOf('month')).startOf('week');
    this.to_date = this.from_date.clone().add(6, 'weeks').subtract(1, 'd');
    this.initCalendar();
  }

  nextMonth() {
    const nextMonth = this.currentDate.clone().add(1, 'month');
    this.from_date = (nextMonth.clone().startOf('month')).startOf('week');
    this.to_date = this.from_date.clone().add(6, 'weeks').subtract(1, 'd');
    this.initCalendar();
  }

  prevYear() {
    const prevYear = this.currentDate.clone().subtract(1, 'year');
    this.from_date = (prevYear.clone().startOf('month')).startOf('week');
    this.to_date = this.from_date.clone().add(6, 'weeks').subtract(1, 'd');
    this.initCalendar();

  }

  nextYear() {
    const nextYear = this.currentDate.clone().add(1, 'year');
    this.from_date = (nextYear.clone().startOf('month')).startOf('week');
    this.to_date = this.from_date.clone().add(6, 'weeks').subtract(1, 'd');
    this.initCalendar();
  }

  get currentMonth() {
    return this.currentDate.locale(this.locale).format('MMMM');
  }
  get currentYear() {
    return this.currentDate.locale(this.locale).format('YYYY');
  }

  private initCalendar() {

    let day = this.from_date;
    this.days = [];
    while (day <= this.to_date) {
      this.days.push(day);
      day = day.clone().add(1, 'd');
    }
    const center = this.viewType === 'week' ? 3 : 15;
    this.currentDate = this.days[center];
  }

  @Input()
  get selectedDate(): Date {
    return this._selectedDate ? this._selectedDate.toDate() : undefined;
  }
  set selectedDate(value: Date) {
    this._selectedDate = moment(value);
  }

  selectDay(date) {
    this.selectedDate = date;
    this.currentDate = date;
    this.selectedDateChange.emit(date.toDate());
  }

  isDisabled(date: Moment): boolean {
    return (
      (this.range && this.range.start && date.isBefore(moment(this.range.start)) && !this.dateUtils.isSame(moment(this.range.start) , date))
      || (this.range && this.range.end && date.isAfter(moment(this.range.end)) && !this.dateUtils.isSame(moment(this.range.end) , date))
      || this.disabledDate(date.toDate())
      || (!date.isSame(this.currentDate, 'month') && this.viewType === 'month')
    );
  }
}
